import React from 'react';
import Datas from '../../data/service/mondiya/service-box.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "../styles/mondiya/serviceBox.js";
import {useTranslation} from "react-i18next";

const ServiceBox = () => {
    const { t } = useTranslation();
    return (
        <Styles>
            {/* Service Box */}
            <section className="service-area">
                <Container>
                    <Row>
                        <Col md="12">
                            <div className="sec-title text-center">
                                <h4>{t(`home.ourServices.secTitle`)}</h4>
                                <p className="sec-para">{t(`home.ourServices.secDesc`)}</p>
                            </div>
                        </Col>
                        {
                            Datas.dataList.map((data, i) => (
                                <Col md="6" key={i}>
                                    <div className="service-box d-flex">
                                        <div className="box-icon">
                                            <i className={data.boxIcon}></i>
                                        </div>
                                        <div className="box-title">
                                            <h6>{t(`home.ourServices.list.${i}.title`)}</h6>
                                            <p>{t(`home.ourServices.list.${i}.subTitle`)}</p>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        }
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default ServiceBox